<template>
	<div class="bar-menu-dashboard-box">
		<div class="bar-menu-bg"></div>

		<div class="bar-menu-dashboard show res-show">
			<div class="user-sidebar-profile bootstrap-fix">
				<div class="bar-user-cover">
					<div class="bar-user-cover-bg">
						<img :src="showCover()">
					</div>
					<div class="bar-user-cover-info">
						<div v-if="$store.state.user" class="bar-user-cover-info-avatar">
							<img :src="$store.state.user.avatar ? ($helpers.api_url() + $store.state.user.avatar.name) : 'https://static.tgju.org/views/default/images/avatar.jpg'">
						</div>
						<div v-if="$store.state.user" class="user-name">
							<span class="user-sidebar-profile-name">
								{{  $store.state.user.firstname +'  '+ $store.state.user.lastname }}
							</span>
							<router-link v-if="!$store.state.user" :to="{ name: 'Login' }" class="btn btn-danger btn-round sidebar-logout-btn auth-btn">
								ورود - عضویت
							</router-link>
							<router-link v-if="$store.state.user" :to="{ name: 'Logout' }" class="btn btn-danger btn-round sidebar-logout-btn">
								خروج
							</router-link>
						</div>
					</div>

				</div>
				<!-- <div class="user-sidebar-profile-cover">
						<div class="user-sidebar-profile-btn">
							<router-link v-if="!$store.state.user" :to="{ name: 'Login' }" class="btn btn-danger btn-round sidebar-logout-btn auth-btn">
								ورود - عضویت
							</router-link>
							<router-link v-if="$store.state.user" :to="{ name: 'Logout' }" class="btn btn-danger btn-round sidebar-logout-btn">
								خروج
							</router-link>
						</div>
					<div v-if="$store.state.user" class="user-sidebar-profile-avatar">
						<img :src="$store.state.user.avatar ? ($helpers.api_url() + $store.state.user.avatar.name) : 'https://static.tgju.org/views/default/images/avatar.jpg'">
					</div>
					<div v-if="$store.state.user" class="user-sidebar-profile-info">
						<span class="user-sidebar-profile-name">
							{{  $store.state.user.firstname +'  '+ $store.state.user.lastname }}
						</span>
					</div>
				</div> -->
			</div>

			<!-- <div class="user-sidebar-profile-list-title">
				منـوها
			</div>		 -->
			<ul class="user-sidebar-profile-list">
				<li v-for="(item, index) in sidebar_items" :key="item.routeName" :class="{ 'active-nav': activeNav == index , 'has-children': item.children.length }">
					<router-link :disabled="item.children.length" :event="!item.children.length ? 'click' : ''" :to="{ name: item.routeName, params: item.routeParams }" class="sub-menu-title-first" @click.native="activeNavToggle(index)">
						<i :class="item.icon"></i>
						<span class="bar-menu-sub-title">{{ item.title }}</span>
						<span class="bullet"></span>
					</router-link>

					<ul v-if="item.children.length">
						<li v-for="(child, index) in item.children" @click="activeSubNavToggle(index)" :class="{ 'active-subnav': activeSubNav == index }" :key="child.routeName + child.routeParams.id" >
							<router-link :to="{ name: child.routeName, params: child.routeParams }">
								<i class="uil uil-angle-left"></i>
								<span class="bar-menu-sub-title">{{ child.title }}</span>
								<span class="bullet"></span>
							</router-link>
						</li>
					</ul>
					<div class="division-bar"></div>
				</li>
			</ul>

			<!--
			<ul v-html="$store.state.sidebar"></ul>
			-->
		</div>
	</div>
</template>

<script>
	// این وویو لی اوت منوی جنبی می باشد
	import ClickOutside from 'vue-click-outside';

	export default {
		name: 'RightNav',
		components: {},
		data: function () {
			return {
				sidebar_items: [
					{
						title: 'پروفایل',
						routeName: 'Profile',
						icon: 'uil uil-user',
						children: [],
					},{
						title: 'داشبوردها',
						routeName: 'Dashboards',
						icon: 'uil uil-create-dashboard',
						children: [],
					},{
						title: 'سبد دارایی',
						routeName: 'Investment',
						icon: 'uil uil-usd-circle',
						children: [
							{
								title: 'عمومی',
								routeName: 'Investment',
								routeParams: "/",
								icon: 'uil uil-list-ol-alt',
							}, {
								title: 'دارایی ها',
								routeName: 'InvestmentInventory',
								routeParams: "inventory",
								icon: 'uil uil-list-ol-alt',
							}, {
								title: 'سوابق خرید',
								routeName: 'InvestmentBuyHistory',
								routeParams: "buy-history",
								icon: 'uil uil-list-ol-alt',
							}, {
								title: 'سوابق فروش',
								routeName: 'InvestmentSellHistory',
								routeParams: "sell-history",
								icon: 'uil uil-list-ol-alt',
							}
						],
					},
					// {
					// 	title: 'بازار‌ها',
					// 	routeName: 'MarketViews',
					// 	icon: 'uil uil-shop',
					// 	children: [],
					// },
					{
						title: 'اتاق‌های گفت‌وگو',
						routeName: 'Forums',
						icon: 'uil uil-comment-alt-lines',
						children: [],
					},{
						title: 'تحلیل‌ها',
						routeName: 'NewTechnical',
						icon: 'uil uil-chart-line',
						children: [],
					}, 
					// {
					// 	title: 'تحلیل‌های من',
					// 	routeName: 'MyTechnical',
					// 	icon: 'uil uil-chart',
					// 	children: [],
					// },
					{
						title: 'هشدارها',
						routeName: 'AlertsView',
						icon: 'uil uil-bell',
						children: [],
					},{
						title: 'فهرست‌ها',
						routeName: 'WatchListsView',
						icon: 'uil uil-list-ui-alt',
						children: [],
					}, {
						title: 'نشان‌شده‌ها',
						routeName: 'FavoritesView',
						icon: 'uil uil-bookmark-full',
						children: [],
					}, 
					// {
					// 	title: 'جدول تقویم اقتصادی ',
					// 	routeName: 'CalendarTable',
					// 	icon: 'uil uil-calendar-slash',
					// 	children: [],
					// },
					{
						title: 'تقویم اقتصادی ',
						routeName: 'CalendarView',
						icon: 'uil uil-calendar-alt',
						children: [],
					}, {
						title: 'وظایف روزانه',
						routeName: 'TodoView',
						icon: 'uil uil-list-ol-alt',
						children: [],
					}, {
						title: 'یادداشت‌ها و اسناد',
						routeName: 'NotesView',
						icon: 'uil uil-notes',
						children: [],
					},
					// {
					// 	title: 'ویجت‌ها',
					// 	routeName: 'WidgetsView',
					// 	icon: 'uil uil-notes',
					// 	children: [],
					// }
					{
						title: 'خروج',
						routeName: 'Logout',
						icon: 'uil uil-signout',
						children: [],
					}
				],
				// notifications_open: true,
				notifications: [],
				activeNav: null,
				activeSubNav: null,
			}
		},

		mounted() {

			// this.notifications_open = true;

			this.$helpers.replace_rel_to_abs('.bar-menu ul:not(.user-sidebar-profile-list) a');

			// کال کردن ایجاد منوی داشبورد های اختصاصی که کاربر ساخته است
			this.setDashboards(this.$store.state.dashboards);
		},

		computed: {
			dashboards_sync () {
				return this.$store.state.dashboards;
			},
			current_route () {
				return this.$store.state.currentRoute;
			},
		},
		methods: {
			// این متد برای ساختن لینک نمایش مناسب آواتار کاربر در هدر استفاده میشود
			showCover() {
				let url = undefined;

				if(this.$route.params.username && this.$helpers.isJson(this.profileUser.opts) )
					url = this.$helpers.api_url() + this.$helpers.json_pars(this.profileUser.opts)['header_cover']['name'];

				if(!this.$route.params.username && this.$helpers.userInfo().opts.header_cover)
					url = this.$helpers.api_url() + this.$helpers.userInfo().opts.header_cover.name;
				
				return url.includes("undefined") ? 'https://static.accessban.com/views/default/images/tgju/dash-header-bd.png' : url;

			},
			// این متد برای شید کردن منوهای جنبی داشبورد می باشد
			activeNavToggle(index) {
				if(this.activeNav == index) { 
					this.activeNav = null;
				} else {
					this.activeNav = index;
				}
			},
			// این متد برای شید کردن ساب منو های جنبی داشبورد می باشد
			activeSubNavToggle(index) {
				if(this.activeNav == index) {
					this.activeNav = null;
				} else {
					this.activeSubNav = index;
				}
			},
			// این متد برای هندل کردن ساب منو های داشبورد های کاربر میباشد
			setDashboards(menu)  {
				let _dashboards = menu ? menu : JSON.parse(localStorage.getItem('dashboards')) ;
				let dashboards = [];
				dashboards = [];

				_dashboards.forEach(dashboard => {
					dashboards.push({
						title: dashboard.title,
						routeName: 'Dashboard',
						routeParams: {id: dashboard.id},
						icon: 'uil uil-angle-left',
					});

					// check if we are in end of _dashboards
					if(_dashboards.indexOf(dashboard) == _dashboards.length - 1) {
						dashboards.push({
							title: 'مدیریت داشبورد‌ها',
							routeName: 'Dashboards',
							routeParams: "/",
							icon: 'uil uil-list-ol-alt',
						});

						// reverse array
						dashboards.reverse();	
					}
				});
				
				if( this.sidebar_items ) this.sidebar_items[1].children = dashboards;
			},
			// open_auth_modal() {
			// 	getAuth();
			// },

			// triggerNotifications(action = null) {
			// 	this.notifications_open = ( action == 'open' ) ? true : false;
			// },

			
		},
		// events: {
		// 	triggerNotifications(action = null) {
		// 		this.notifications_open = ( action == 'open' ) ? true : false;
		// 	}
		// },

		directives: {
			ClickOutside
		},
		// در متد واچ 
		watch: {
			dashboards_sync : {
				handler: function (dashboards_sync, oldVal) {
					this.setDashboards(this.$store.state.dashboards);
				},
				deep: true 
			},
			current_route : {
				handler: function (current_route, oldVal) {},
				deep: true 
			},
		}
	}
</script>